import { render } from "./planning_comunicaciones.vue?vue&type=template&id=0bf6d16d"
import script from "./planning_comunicaciones.vue?vue&type=script&lang=js"
export * from "./planning_comunicaciones.vue?vue&type=script&lang=js"

import "./planning_comunicaciones.vue?vue&type=style&index=0&id=0bf6d16d&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__